export const STANDARD_FIELD_TYPES = {
  DATA_TYPE: 'DATA_TYPE',
  PRIMARY_DATA_SOURCE_ID: 'PRIMARY_DATA_SOURCE_ID',
  ALL_DATA_SOURCE_IDS: 'ALL_DATA_SOURCE_IDS',
  DIMENSIONS: 'DIMENSIONS',
  METRICS: 'METRICS',
  CHART_TYPE: 'CHART_TYPE',
  REPORT_RESOLVE: 'REPORT_RESOLVE'
};